<div class="table-contents">
  <span>{{ 'visualiser.libelle_table_matieres' | translate }}</span>
  <ul>
    <li>niveau1</li>
    <li>niveau2</li>
    <li>niveau3</li>
  </ul>
</div>
